// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { get } from "@insite/client-framework/Services/ApiService";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

export interface FeaturedProductsApiParameter {
    pageSize: number;
    pageNumber?: number;
}

const serviceUri = "api/custom/FeaturedProducts/GetFeaturedProducts";

export async function getFeaturedProducts(params: FeaturedProductsApiParameter) {
    try {
        const featuredProducts = await get<{ data: ProductModel[]; rowCount: number }>(
            `${serviceUri}?pageSize=${params.pageSize}${params.pageNumber ? `&pageNumber=${params.pageNumber}` : ""}`,
        );
        return {
            successful: true,
            featuredProducts,
        };
    } catch (e) {
        return {
            successful: false,
            error: e,
        };
    }
}
